import { Navigate } from 'react-router-dom';
import { useAuth } from '@/app/providers';
import { ROUTES } from '@/config/constants';
import { SignInPanel } from './components/SignInPanel';

export function SignInPage() {
  const { user, loading } = useAuth();
  if (!loading && user) return <Navigate to={ROUTES.explore} replace />;
  return (
    <div className="flex min-h-[80vh] items-center justify-center px-5">
      <SignInPanel />
    </div>
  );
}
